import setGlobalState, {pushToGlobalState} from '../setGlobalState';
import request, {cancelableRequest} from '../../library/request';
import store from '../../store';
import {getPid} from '../categories/categoriesActions';
import { paginatedRequest } from '../utils/paginatedFetch';

const getEid = () => store.getState().event.eid;

// **NOTE: All functions below are commented out and are for example purposes only**

// Subscription Events Actions
// // export const getSubscriptions = async () => {
//     const res = await request('subscription.getSubscriptions', 'get', '/subscriptions');
//     setGlobalState('subscription.subscriptionEvents', res.subscriptions || []);
// };

// export const updateSubscription = async (subscriptionId, subscriptionData) => {
//     const res = await request('subscription.updateSubscription', 'put', `/subscriptions/${subscriptionId}`, subscriptionData);
//     await getSubscriptions();
//     return res;
// };

// export const deleteSubscription = async (subscriptionId) => {
//     const res = await request('subscription.deleteSubscription', 'delete', `/subscriptions/${subscriptionId}`);
//     await getSubscriptions();
//     return res;
// };

// Subscription Plans Actions
export const getPlans = async () => {
    const eid = getEid();
    const plans = await paginatedRequest(
        async (limit, offset) => {
            return await request('subscription.getPlans', 'get', `/event/${eid}/subscription`, {limit, offset});
        },
        'plans',
        'subscription.subscriptionPlans'
    );
    return {plans}
};

// Create subscription plan
export const createPlan = async (planData: any) => {
    const eid = getEid();
    const res = await request('subscription.createPlan', 'post', `/event/${eid}/subscription/plan`, planData);

    if(res?.plan) {
        const planTid = res.plan.planTid;
        setGlobalState('subscription.currentPlan', planTid);
        pushToGlobalState('subscription.subscriptionPlans', res.plan);
    }
};

// Update subscription plan
export const updatePlan = async (planTid: any, planData: any) => {
    const eid = getEid();
    const res = await request('subscription.updatePlan', 'put', `/event/${eid}/subscription/plan/${planTid}`, planData);

    if(res?.plan) {
        const updatedplanTid = res.plan.planTid;
        setGlobalState('subscription.currentPlan', updatedplanTid);
        const currentPlans = store.getState().subscription.subscriptionPlans || [];
        const updatedPlans = currentPlans.map((plan: any) =>
            (plan.planTid === res.plan.planTid || plan.planTid === planTid) ? res.plan : plan
        );
        setGlobalState('subscription.subscriptionPlans', updatedPlans);
    }
};

// export const deletePlan = async (planTid) => {
//     const res = await request('subscription.deletePlan', 'delete', `/subscription-plans/${planTid}`);
//     await getPlans();
//     return res;
// };

// // Plan Events Actions
// export const getPlanEvents = async (planTid) => {
//     const res = await request('subscription.getPlanEvents', 'get', `/subscription-plans/${planTid}/events`);
//     setGlobalState('subscription.planEvents', res.events || []);
//     return res;

// };

// export const linkEventToPlan = async (planTid, eventId) => {
//     const res = await request('subscription.linkEventToPlan', 'post', `/subscription-plans/${planTid}/events`, {eventId});
//     setGlobalState('subscription.linkEventToPlanXHR', 'SUCCESS');
//     await getPlanEvents(planTid);
//     return res;
// };

// Get subscription plan by ID
export const getPlan = async (planTid: any) => {
    const eid = getEid();
    const res = await request('subscription.getPlan', 'get', `/event/${eid}/subscription/plan/${planTid}`);
    if(res?.plan) {
        const planTidValue = res.plan.planTid || planTid;
        setGlobalState('subscription.currentPlan', planTidValue);
        // Update the plan in subscriptionPlans array
        const currentPlans = store.getState().subscription.subscriptionPlans || [];
        const planIndex = currentPlans.findIndex((p: any) =>
            p.planTid === planTidValue
        );
        if(planIndex >= 0) {
            const updatedPlans = [...currentPlans];
            updatedPlans[planIndex] = res.plan;
            setGlobalState('subscription.subscriptionPlans', updatedPlans);
        } else {
            pushToGlobalState('subscription.subscriptionPlans', res.plan);
        }
    }
    return res;
};

// Get plan events (assigned events)
export const getPlanEvents = async (planTid: number) => {
    const eid = getEid();
    const res = await request('subscription.getPlanEvents', 'get', `/event/${eid}/subscription/${planTid}/events`);
    if(res?.events) {
        // Store events in subscription.events
        setGlobalState('subscription.events', res.events);
    }
    return res;
};

// Assign events to subscription plan
export const assignEventsToPlan = async (planTid: number, events: number[]) => {
    const eid = getEid();
    const res = await request('subscription.assignEventsToPlan', 'post', `/event/${eid}/subscription/${planTid}/events`, {events});
    
    if(res) {
        // Update the plan's eventsEids in the subscriptionPlans array
        const currentPlans = store.getState().subscription.subscriptionPlans || [];
        const updatedPlans = currentPlans.map((plan: any) =>
            plan.planTid === planTid ? {...plan, eventsEids: events} : plan
        );
        setGlobalState('subscription.subscriptionPlans', updatedPlans);
    }
    return res;
};

// Set plan ID for editing
export const setCurrentPlan = (planTid: number | null) => {
    setGlobalState('subscription.currentPlan', planTid);
};

// Price Groups Actions
export const getPriceGroups = async () => {
    const eid = getEid();
    const res = await request('subscription.getPriceGroups', 'get', `/event/${eid}/subscription/priceGroups`);
    if(res?.priceGroups) {
        setGlobalState('subscription.priceGroups', res.priceGroups || []);
    }
    return res;
};

// Get price groups by package
export const getPriceGroupsByPackage = async () => {
    const pid = store.getState().account.pid;
    if(!pid) {
        return;
    }    
    return await paginatedRequest(
        async (limit, offset) => {
            return await request('subscription.getPriceGroupsByPackage', 'get', `/package/${pid}/priceGroups`, {limit, offset});
        },
        'priceGroups',
        'subscription.priceGroups'
    );
};

export const createPriceGroup = async (priceGroupData: any, options?: {handleError?: boolean}) => {
    const eid = getEid();
    const res = await request('subscription.createPriceGroup', 'post', `/event/${eid}/subscription/priceGroups`, priceGroupData, options);
    if(res?.priceGroup) {
        pushToGlobalState('subscription.priceGroups', res.priceGroup);
    }
    return res;
};

export const updatePriceGroup = async (id: number, priceGroupData: any) => {
    const eid = getEid();
    const res = await request('subscription.updatePriceGroup', 'put', `/event/${eid}/subscription/priceGroups/${id}`, priceGroupData);
    if(res?.priceGroup) {
        const currentGroups = store.getState().subscription.priceGroups || [];
        const updatedGroups = currentGroups.map((group: any) =>
            group.spgId === id ? res.priceGroup : group
        );
        setGlobalState('subscription.priceGroups', updatedGroups);
    }
    return res;
};

export const deletePriceGroup = async (id: number) => {
    const eid = getEid();
    const res = await request('subscription.deletePriceGroup', 'delete', `/event/${eid}/subscription/priceGroups/${id}`);
    if(res?.success) {
        const subscriptionData = store.getState().subscription;
        // Remove from priceGroups list
        const filteredGroups = (subscriptionData.priceGroups || []).filter((group: any) => group.spgId !== id);
        setGlobalState('subscription.priceGroups', filteredGroups);

        // Remove from all subscription plans that use this price group
        const currentPlans = subscriptionData.subscriptionPlans || [];
        const updatedPlans = currentPlans.map((plan: any) => {
            if(plan.priceGroups && Array.isArray(plan.priceGroups)) {
                const filteredPriceGroups = plan.priceGroups.filter((pg: any) => pg.spgId !== id);
                return {
                    ...plan,
                    priceGroups: filteredPriceGroups.length > 0 ? filteredPriceGroups : null
                };
            }
            return plan;
        });
        setGlobalState('subscription.subscriptionPlans', updatedPlans);
    }
};

export const findPriceGroupByRange = async (minPrice: number, maxPrice: number) => {
    const eid = getEid();
    const res = await request('subscription.findPriceGroupByRange', 'get',
        `/event/${eid}/subscription/priceGroups/findByRange?minPrice=${minPrice}&maxPrice=${maxPrice}`);
    return res;
};

export const getPriceGroupImpact = async (id: number) => {
    const eid = getEid();
    const res = await request('subscription.getPriceGroupImpact', 'get', `/event/${eid}/subscription/priceGroups/${id}/impact`);
    return res;
};

export const linkPriceGroupsToPlan = async (planTid: number, priceGroupIds: number[]) => {
    const eid = getEid();
    const res = await request('subscription.linkPriceGroupsToPlan', 'post',
        `/event/${eid}/subscription/plan/${planTid}/priceGroups`,
        {priceGroupIds});
    return res;
};

export const unlinkPriceGroupsFromPlan = async (planTid: number, priceGroupIds: number[]) => {
    const eid = getEid();
    const res = await request('subscription.unlinkPriceGroupsFromPlan', 'delete',
        `/event/${eid}/subscription/plan/${planTid}/priceGroups`,
        {priceGroupIds});
    return res;
};

export const getSubscriptionEvents = async ({limit, offset}) => {    
    const res = await cancelableRequest('subscription.getSubscriptionEvents', 'get', `/package/${getPid()}/subscriptionEvents`, {limit, offset});
    if(res?.events) {
        const existingEvents = store.getState().subscription.events || [];
        if(res?.events?.length > 0) {
            setGlobalState('subscription.events', [...existingEvents, ...res.events]);
        }
    }
};
